import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import { ProductLocalStoreAvailabilityEvent } from 'PyzShopUi/scripts/react/common/events/productLocalStoreAvailabilityEvent';

export const changeLocalStoreAvailabilityButtonConcreteId = (id_product_concrete: any) => {
    MiddlewareEventBus.getInstance().publish({type: ProductLocalStoreAvailabilityEvent.UPDATE_CONCRETE, payload: id_product_concrete});
}

export const disableLocalStoreAvailabilityButton = () => {
    MiddlewareEventBus.getInstance().publish({type: ProductLocalStoreAvailabilityEvent.DISABLE, payload: {}});
}
